import { useFilter } from '../AssetManagerContext';
import { useState } from 'react';
import { EyeOutlined, DownOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

export function ViewSelectionMenu() {
    const { setVisibleCols, setTempCols } = useFilter();
    const [open, setOpen] = useState(false);
    const [view, setView] = useState('All Columns');

    // define preset views
    const viewPresets = {
        Address: [],
        'Basic Info': [
            'Title Holder',
            'Project Strategy',
            'Business Line',
            'Property Type',
            'Occupancy Status',
            'HOA',
            'Solar Panel',
            'Insurance Policy',
            'Annual Property Tax',
            'Annual Insurance Premium',
            'As Is Market Value',
            'Equity',
            'Monthly PITI',
            'LTV',
            'Cash Invested',
            'Total Cost',
            'Estimated Profit',
            'Cost of Capital',
            'PL Link',
            'Grand Deed',
        ],
        'Transaction Info': [
            'Purchase Price',
            'Under Constract Date',
            'Transaction Status',
            'Purchase Close Date',
            'Title Binder Info',
            'Title History',
            '1031 Company Info',
            'Target Exit Date',
            'Relisting Agent',
            'Sold Price',
            'Sold Date',
        ],
        'Loan Info': [
            'Loan Status',
            'Outstanding Loan Amount',
            'Monthly Mortgage Payment',
            'Loan Prepay Restriction',
            'Loan Service Company',
            'Loan Type',
            'Rehab Loan Budget',
            'Released Rehab Loan',
            'Lien',
            'Impound',

            'Loan Amount (1st)',
            'Lender (1st)',
            'Rate (1st)',
            'Maturity Date (1st)',

            'Loan Amount (2nd)',
            'Lender (2nd)',
            'Rate (2nd)',
            'Maturity Date (2nd)',

            'Loan Amount (3rd)',
            'Lender (3rd)',
            'Rate (3rd)',
            'Maturity Date (3rd)',

            'Loan Amount (4th)',
            'Lender (4th)',
            'Rate (4th)',
            'Maturity Date (4th)',
        ],
        'Rental Info': [
            'Rental Status',
            'Monthly Rent',
            'Lease Start Date',
            'Lease Expire Date',
        ],
        'All Columns': 'ALL', // show all
    };

    const handleSelectView = (viewName) => {
        setView(viewName);
        const preset = viewPresets[viewName];
        if (!preset) return;

        const isAll = preset === 'ALL';

        // helper to compute new visibility map
        const nextCols = (prev) =>
            Object.keys(prev).reduce((acc, key) => {
                acc[key] = isAll || preset.includes(key);
                return acc;
            }, {});

        setVisibleCols(nextCols);
        setTempCols(nextCols);

        setOpen(false);
    };

    const overlayContent = (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                background: 'white',
                border: '1px solid #f0f0f0',
                borderRadius: 6,
                width: 200,
                overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {Object.keys(viewPresets).map((viewName) => {
                const isSelected = viewName === view;
                return (
                    <div
                        key={viewName}
                        onClick={() => handleSelectView(viewName)}
                        style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: isSelected ? '#e6f4ff' : 'white',
                            color: isSelected ? '#1677ff' : '#333',
                            // borderBottom: '1px solid #f5f5f5',
                            transition: 'all 0.15s ease',
                        }}
                        onMouseEnter={(e) => {
                            if (!isSelected)
                                e.currentTarget.style.backgroundColor =
                                    '#fafafa';
                        }}
                        onMouseLeave={(e) => {
                            if (!isSelected)
                                e.currentTarget.style.backgroundColor = 'white';
                        }}
                    >
                        <span>{viewName}</span>
                        {isSelected && (
                            <CheckOutlined style={{ color: '#1677ff' }} />
                        )}
                    </div>
                );
            })}
        </div>
    );

    return (
        <Dropdown
            dropdownRender={() => overlayContent}
            trigger={['click']}
            open={open}
            onOpenChange={setOpen}
            placement="bottomLeft"
        >
            <Button icon={<EyeOutlined />}>
                {view === 'All Columns' ? 'View' : view} <DownOutlined />
            </Button>
        </Dropdown>
    );
}
